import { render, staticRenderFns } from "./policy.vue?vue&type=template&id=902f64f6&scoped=true&"
import script from "./policy.vue?vue&type=script&lang=ts&"
export * from "./policy.vue?vue&type=script&lang=ts&"
import style0 from "./policy.vue?vue&type=style&index=0&id=902f64f6&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "902f64f6",
  null
  
)

export default component.exports